import { useCallback, useState } from 'react'

import { ApiError } from '@api'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router'

import { LoadingPageContent } from '@/components/layout/page/loading-page-content.tsx'
import { editScriptFx } from '@/models/scripts/scripts.ts'
import type { EditorForm } from '@/modules/scripts/components/ScriptEditView'
import { ScriptEditView } from '@/modules/scripts/components/ScriptEditView'
import { useScript } from '@/modules/scripts/components/ScriptProvider'
import { AppRoutes } from '@/utils/constants'
import { useCreatorUrl } from '@/utils/creators.ts'

export const EditScriptPage = () => {
  const scriptQuery = useScript()
  const { isFetching, data: script } = scriptQuery
  const [error, setError] = useState<Nullable<ApiError>>(null)
  const isLoading = useUnit(editScriptFx.pending)

  const navigate = useNavigate()
  const listUrl = useCreatorUrl(AppRoutes.Creator.Settings.Scripts.List)

  const handleBack = useCallback(() => navigate(listUrl), [navigate, listUrl])

  const handleEdit = useCallback(
    async (state: EditorForm) => {
      if (!script?.id) {
        return
      }
      try {
        await editScriptFx({
          id: script.id,
          name: state.title ?? '',
          category: state.category!,
          message: {
            text: state.text,
            enableFallbackVariable: state.enableFallbackVariable,
            fallbackVariable: state.fallbackVariable!,
            fallback: state.fallback!,
            // @ts-ignore
            medias: state.medias!,
            price: state.price!,
          },
        })
        navigate(-1)
      } catch (error) {
        setError(error as ApiError)
      }
    },
    [navigate, script],
  )

  return isFetching || !script ? (
    <LoadingPageContent />
  ) : (
    <ScriptEditView
      mode="edit"
      script={script}
      isFetching={isFetching}
      onBack={handleBack}
      onSave={handleEdit}
      isSaving={isLoading}
      error={error}
    />
  )
}
